import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { ReceiptInventory } from "../models/receipt.model";

import "firebase/firestore";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root",
})
export class ReceiptInventoryService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<ReceiptInventory>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions,
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getReceiptInventories(
    shopId: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<ReceiptInventory> {
    return this.db.collection(
      this.dbPath + `/${shopId}/receipt-inventories`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("issueDate", ">=", fromDate)
          .where("issueDate", "<=", toDate)
          .orderBy("issueDate", "desc"),
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/receipt-inventories`)
      .doc(id)
      .valueChanges();
  }

  getReceiptInventory(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/receipt-inventories`)
      .doc(id);

    return ref.get();
  }

  create(receipt: ReceiptInventory): any {
    let obj = _.clone(receipt);
    delete obj.id;
    obj.receiptInventoryDetails =
      receipt.receiptInventoryDetails.length > 0
        ? JSON.parse(JSON.stringify(receipt.receiptInventoryDetails))
        : [];

    obj.isDelivered = false;
    obj.deliveredDate = new Date();

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipt-inventories`,
    );

    console.log("create receipt:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      receipt.id = docRef.id;
      receipt.author = this.userLogin;
      return receipt;
    });
  }

  update(receipt: ReceiptInventory): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipt-inventories`,
    );

    console.log("update receipt:", receipt);

    return this.collRef.doc(receipt.id).update({
      issueDate: receipt.issueDate,
      issueDateSeconds: receipt.issueDateSeconds,
      issueDateMinutes: receipt.issueDateMinutes,
      issueDateHours: receipt.issueDateHours,
      issueDateDay: receipt.issueDateDay,
      issueDateWeekDay: receipt.issueDateWeekDay,
      issueDateMonth: receipt.issueDateMonth,
      issueDateYear: receipt.issueDateYear,
      code: receipt.code ? receipt.code : "",
      note: receipt.note ? receipt.note : "",
      tags: receipt.tags ? receipt.tags : [],
      status: receipt.status,
      warehouseId: receipt.warehouseId ? receipt.warehouseId : "",
      warehouseName: receipt.warehouseName ? receipt.warehouseName : "",

      detailAmount: receipt.detailAmount,
      detailNetAmount: receipt.detailNetAmount,
      totalQuantity: receipt.totalQuantity,
      totalAmount: receipt.totalAmount,

      isCancel: receipt.isCancel,
      isClosed: receipt.isClosed,
      isPrint: receipt.isPrint,
      noPrint: receipt.noPrint,
      isTrade: !!receipt.isTrade,
      totalCostAmount: receipt.totalCostAmount ? receipt.totalCostAmount : 0,
      totalProfit: receipt.totalProfit ? receipt.totalProfit : 0,

      receiptInventoryDetails:
        receipt.receiptInventoryDetails.length > 0
          ? JSON.parse(JSON.stringify(receipt.receiptInventoryDetails))
          : [],

      employeeSaleId: receipt.employeeSaleId ? receipt.employeeSaleId : "",
      employeeSaleName: receipt.employeeSaleName
        ? receipt.employeeSaleName
        : "",

      employeeCounSellorId: receipt.employeeCounSellorId
        ? receipt.employeeCounSellorId
        : "",
      employeeCounSellorName: receipt.employeeCounSellorName
        ? receipt.employeeCounSellorName
        : "",

      employeeDeliveryId: receipt.employeeDeliveryId
        ? receipt.employeeDeliveryId
        : "",
      employeeDeliveryName: receipt.employeeDeliveryName
        ? receipt.employeeDeliveryName
        : "",

      isDelivery: !!receipt.isDelivery,
      deliveryDate: receipt.deliveryDate ? receipt.deliveryDate : new Date(),
      deliveryNote: receipt.deliveryNote ? receipt.deliveryNote : "",

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(
      this.dbPath + `/${shopId}/receipt-inventories`,
    );
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
